// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Liberia from '../_raw/flag/icon_flag_liberia.png';

export default () => <img src={Liberia} alt="Liberia" />;
